import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Container, Grid, Image } from "semantic-ui-react"
import '../styles/article.css'
import ArticleItem from './ArticleItem';
import infoTornado from '../assets/shutterstock_2294406661_circle.png'
import { fetchArticles } from '../slices/coreAssetsSlice'
import useIsLoggedIn from '../isLoggedIn';
import { AuthStdFooter } from "../utils/auth-std-footer"

// let articleListOptions = [{ key: 'noitems', text: "Article Item", value: 'noitems', data: {} }]


export default function ArticleItemContainer() {
  const dispatch = useDispatch()
  // const { id } = useParams();
  const activeArticle = useSelector((state) => state.core.activeArticle);

  // const articleList = useSelector((state) => {
  //   // console.log('allArticles', state.core.articles.articles);
  //   if (state.core.articles.articles) {
  //     articleListOptions = state.core.articles.articles.map((x) => {
  //       let key_value = x.name.replace(/[^a-z0-9]/gi, '').toLowerCase()
  //       return { key: key_value, text: x.name, value: key_value, data: x }
  //     })
  //     // console.log('allArticles', articleListOptions);

  //   }
  //   return state.core.articles.articles;
  // })
  const authToken = useIsLoggedIn();

  useEffect(() => {
    let props = { uuid: '2cc388cb-ae96-3edb-1136-14c1b0c0324d', reqCategories: "" }
    dispatch(fetchArticles(props))
      .unwrap()
      .then((data) => {
        // handle success here
        // console.log('success articles fetch', data)
      })
      .catch((error) => {
        // handle error here
        // console.log('failed articles fetch', error.message)

      });

  }, [dispatch, authToken])

  useEffect(() => {
    if (activeArticle) {
      // console.log('ArticleItemContainer', activeArticle)
    }
  }, [activeArticle])

  const getArticleItem = (uuid) => {
    return <ArticleItem uuid={uuid} />
  }

  const articlePage = () => {
    return (
      <>
        <div className="std-pg-main-area std-pg-grey-background-color" style={{ marginBottom: "70px" }}>
          <Container style={{ marginTop: "30px", marginBottom: "200px" }}>
            <Grid className="articleListWidth">
              <Grid.Row>
                <Grid.Column width={3} >
                  <div className="img-with-gradient">
                    <Image src={infoTornado} />
                  </div>
                </Grid.Column>
                <Grid.Column width={13} textAlign="center">
                  <span className="blgListItemTitle">Authorator Information</span>
                  <span className="blgListSubTitle">Ways and Whys</span>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid className="articleListWidth" style={{ marginTop: "20px", borderTop: "solid 1px #AAAAAA" }}>
              <>{getArticleItem(activeArticle)}</>
            </Grid>
          </Container>
          {AuthStdFooter()}

        </div >
      </>
    )
  }
  return (<>{articlePage()}</>)

} 